import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box } from '@mui/material'

import LanguageContext from "../../../contexts/LanguageContext"
import { useTexte } from "../../../contexts/FormeAdresseContext"
import UserContext from "../../../contexts/UserContext"

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import { TopBar, CenterContainer, casseNormale, BLOC_DEFILANT, FonduBas, sansBlancsAutour, BlocIllustre, ImageCarree, IMAGE_PLEINE, imagePleine, coteDeLImage, DEGRADE_PANNEAU, useApercuPleineHauteur, useDebordeEnBas, LARGEUR_CONTENU, COLONNE_ILLUSTREE, LARGEUR_CARTES, LARGEUR_QUESTION, BandeReponse, useRaccourciClavier, saisieEnCours, ROGNE_HAUT, RESERVE_ACCENTS, retraitPlanche, HAUTEUR_PLANCHE, MARGE_QUESTION, LARGEUR_IMAGE, FENETRE_COURTE } from "./FormatsHelpers"
import { quizVariant, QUIZ_VRAI_FAUX } from "../../../utils/quizVariant"
import { APERCU_EDITO } from "./apercu"
import { correctionDemandeeAuServeur, correctionExploitable, poserCorrection } from "../../../utils/scoresServeur"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"
import QuizzHelper from "../../ui/Admin/Formations/FormatHelpers/QuizzHelper"


/* PD-23 : la valeur de la planche a sa hauteur, l'ancienne en dessous (voir
   l'appel de CenterContainer et `retraitPlanche`). */
const RETRAIT_QUIZ = [
  retraitPlanche(24, 51, HAUTEUR_PLANCHE.mobile),       /* 3:382572 : 51 px */
  retraitPlanche(32, 162, HAUTEUR_PLANCHE.tablette),    /* 3:382627 : 162 px */
  retraitPlanche(48, 120, HAUTEUR_PLANCHE.desktop),     /* 3:302251 : 120 px */
  retraitPlanche(48, 120, HAUTEUR_PLANCHE.desktop),
]
/* Vrai/Faux (planche 11, 04/10/2026) : pastille a 120 px de l'en-tete en
   Desktop (6:302), 162 en Tablet (34:1199), 80 en Mobile (34:1244). */
const RETRAIT_VRAI_FAUX = [
  retraitPlanche(24, 79, HAUTEUR_PLANCHE.mobile),
  retraitPlanche(32, 162, HAUTEUR_PLANCHE.tablette),
  retraitPlanche(48, 120, HAUTEUR_PLANCHE.desktop),
  retraitPlanche(48, 120, HAUTEUR_PLANCHE.desktop),
]
/* 40 px entre cartes et controles sur la planche sans image (3:302259,
   3:382636), 20 avant : meme regle, 40 a la hauteur de la planche seulement. */
const ECART_QUIZ = [
  "20px",
  retraitPlanche(20, 40, HAUTEUR_PLANCHE.tablette),
  retraitPlanche(20, 40, HAUTEUR_PLANCHE.desktop),
  retraitPlanche(20, 40, HAUTEUR_PLANCHE.desktop),
]
const FormatQuizz = ({ actFormation, actIndex, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)
  /* Tutoiement / vouvoiement selon la cible du module (07/10/2026,
     contexts/FormeAdresseContext.js). */
  const t = useTexte()

  const { manageFormatResponse, manageSlide, signalerSessionExpiree, repondreSequence } = useContext(UserContext)

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }


  const [isAlreadyAnswer, setIsAlreadyAnswer] = useState(false)

  /* 05/10/2026 (PD-34) : « Valider » et « Suivant » occupent la MEME place a
     l'ecran. Un double clic (ou une touche Entree tenue) validait, puis le 2e
     geste tombait sur « Suivant » : l'apprenant quittait l'ecran sans voir la
     correction ni l'explication. « Suivant » ignore donc tout geste dans la
     demi-seconde qui suit l'affichage de la reponse. Un humain qui lit n'est pas
     gene ; un double clic l'est. */
  const DELAI_AVANT_SUIVANT_MS = 500
  const reponseMontreeA = useRef(0)
  useEffect(() => {
    if (isAlreadyAnswer) reponseMontreeA.current = Date.now()
  }, [isAlreadyAnswer])
  const allerAuSuivant = () => {
    if (Date.now() - reponseMontreeA.current < DELAI_AVANT_SUIVANT_MS) return
    manageSlide(1)
  }

  /* ⛔ Le bloc d'explication s'ajoute SOUS les propositions. Mesure au banc,
     1440x900 : avec quatre propositions, la colonne est deja pleine, et le
     bloc naissait donc hors du cadre. L'apprenant validait, ne voyait rien
     changer, et cliquait « Continuer » sans avoir lu l'explication — le
     defaut exact que le bloc etait cense reparer.
     La barre de defilement le signale desormais (arbitrage fiche V2), mais
     signaler ne suffit pas ici : c'est la reponse a sa question, elle doit
     venir a lui. On amene donc le bloc a l'ecran des qu'il apparait.
     `block: nearest` ne bouge rien s'il est deja visible : sur un quiz court,
     l'ecran ne saute pas. */
  const refExplication = useRef(null)
  /* 01/10/2026 : le fondu de la bande ne s'affiche que s'il reste du contenu
     sous la ligne de flottaison (voir `useDebordeEnBas`). */
  const [refDefilant, debordeEnBas] = useDebordeEnBas()
  useEffect(() => {
    if (!isAlreadyAnswer || isEditor) return
    const n = refExplication.current
    if (!n || typeof n.scrollIntoView !== "function") return
    /* ⚠️ ARBITRAGE OUVERT (mesure du 08/09, 1440 x 900). Le bloc contient
       617 px pour un cadre de 390 : on ne peut pas montrer a la fois les
       propositions colorees et l'explication. `nearest` privilegie
       l'explication — decision anterieure, prise parce que des apprenants
       cliquaient « Continuer » sans l'avoir lue. Les reponses colorees sont
       alors a un cran de molette au-dessus.
       Une variante amenant le haut de l'explication a mi-hauteur a ete testee
       et mesuree : elle ne gagne que 11 px, le contenu debordant de toute
       facon. Elle a donc ete retiree.
       Question posee a Nawal : faut-il inverser la priorite ? */
    const t = setTimeout(() => {
      n.scrollIntoView({ behavior: "smooth", block: "nearest" })
    }, 120)
    return () => clearTimeout(t)
  }, [isAlreadyAnswer, isEditor])
  const [responses, setResponses] = useState([])

  /* 27/09/2026, chantier « scores cote serveur » : pour un candidat THE SCAN que
     le serveur ne corrige plus dans le navigateur, la validation part au
     serveur (voir `validerParLeServeur`). Trois choses a tenir pendant l'aller
     et retour :
     - UN SEUL ENVOI. La reference bloque un second clic arrive avant que le
       bouton desactive soit rendu ; l'etat, lui, desactive le bouton a l'ecran.
       Le choix aussi est fige : sinon l'ecran afficherait un choix different
       de celui que le serveur enregistre ;
     - L'ECHEC SE DIT SUR L'ECRAN, qui reste non repondu et se revalide ;
     - L'ECRAN AFFICHE peut avoir change pendant l'envoi : la reponse arrivee
       ne s'applique qu'a l'ecran qui l'a envoyee, s'il est encore la. */
  const [envoiEnCours, setEnvoiEnCours] = useState(false)
  const envoiRef = useRef(false)
  const [echecEnvoi, setEchecEnvoi] = useState(false)
  const formatAffiche = useRef(format)
  useEffect(() => () => { formatAffiche.current = null }, [])

  useEffect(() => {
    formatAffiche.current = format
    setEchecEnvoi(false)
    if (format?.isDone) {
      setIsAlreadyAnswer(true)
      if (format?.userChoice) {
        setResponses(format?.userChoice)
      } else {
        setResponses([])
      }
    } else {
      setIsAlreadyAnswer(false)
      setResponses([])
    }
  }, [format])

  // La validite etait calculee dans le gestionnaire de validation uniquement.
  // Le bloc d'explication (L63) en a besoin aussi au rendu, y compris quand on
  // revient sur une question deja repondue : on l'extrait ici pour n'avoir
  // qu'une seule regle.
  const estJuste = (choix) => {
    if (format?.noValidAnswer) return true
    const toutes = format?.responses || []
    for (let i = 0; i < toutes.length; i++) {
      const choisie = choix?.find((el) => el === i) !== undefined
      if (toutes[i]?.isValid === true && !choisie) return false   // bonne reponse oubliee
      if (toutes[i]?.isValid === false && choisie) return false   // mauvaise reponse cochee
    }
    return true
  }
  /* l'explication s'affiche apres la reponse, s'il y a un texte (ou en
     editeur) : meme regle que le bloc d'explication plus bas */
  const texteExplication = ((format?.responses || []).some((r) => r && r.isValid) && estJuste(responses)) ? format?.success : format?.fail
  const explicationVisible = isAlreadyAnswer && format?.noValidAnswer !== true && (isEditor || !!(texteExplication && String(texteExplication).trim()))

  const handleClick = (item, i) => {
    if (isAlreadyAnswer === false && envoiRef.current === false) {
      if (format?.multi) {
        //choix multiple
        let actReps = [...responses]
        let findInActReps = actReps.find((el) => el === i)
        if (findInActReps === undefined) {
          actReps.push(i)
        } else {
          actReps = actReps.filter((el) => el !== i)
        }
        setResponses(actReps.sort())
      } else {
        //une seule réponse possible
        setResponses([i])
      }
    }
  }

  const validQuizz = () => {
    if (isEditor) { return null }

    /* 27/09/2026 : candidat THE SCAN sans bonnes reponses livrees, c'est le
       serveur qui corrige. Tous les autres cas (apprenant, admin, essai,
       candidat servi par l'ancien serveur) gardent le chemin ci-dessous. */
    if (correctionDemandeeAuServeur(actFormation, format)) {
      return validerParLeServeur()
    }

    let userIsValid = estJuste(responses) ? 1 : 0

    setIsAlreadyAnswer(true)
    manageFormatResponse(format, [{ key: 'isDone', value: true }, { key: 'userChoice', value: responses }, { key: 'userIsValid', value: userIsValid }])
    if (format?.noValidAnswer === true) {
      manageSlide(1)
    }
  }

  const validerParLeServeur = async () => {
    if (envoiRef.current) return
    envoiRef.current = true
    setEnvoiEnCours(true)
    setEchecEnvoi(false)
    const idEnvoye = format?.id
    let reponse = null
    /* 27/09/2026 : l'envoi passe par le contexte, qui porte les gardes de
       l'essai et de l'apercu admin. Une exception inattendue vaut un echec :
       l'ecran doit redevenir utilisable. */
    try {
      reponse = await repondreSequence(idEnvoye, responses)
    } catch (e) {
      reponse = null
    } finally {
      envoiRef.current = false
      setEnvoiEnCours(false)
    }
    const cible = formatAffiche.current
    if (!cible || cible.id !== idEnvoye) return

    if (!correctionExploitable(reponse, cible)) {
      if (reponse?.sessionExpiree === true && typeof signalerSessionExpiree === "function") {
        signalerSessionExpiree()
        return
      }
      setEchecEnvoi(true)
      return
    }

    /* Succes, ou 409 : le serveur avait deja une AUTRE reponse. Dans les deux
       cas on affiche ce qu'il a ENREGISTRE (son `userChoice`), pas ce qui
       etait coche, puis on renvoie les memes valeurs par le chemin habituel :
       le serveur accepte ce renvoi identique, et l'etat du lecteur reste
       coherent avec la base. */
    const c = reponse.correction
    const choixEnregistre = reponse.userChoice
    poserCorrection(cible, c)
    setResponses(choixEnregistre)
    setIsAlreadyAnswer(true)
    manageFormatResponse(cible, [{ key: 'isDone', value: true }, { key: 'userChoice', value: choixEnregistre }, { key: 'userIsValid', value: c.userIsValid ? 1 : 0 }],
      // 27/09/2026 (relecture) : la reponse est deja en base, voir saveUserFormation.
      { reponseDejaEnregistree: true })
    if (cible?.noValidAnswer === true) {
      manageSlide(1)
    }
  }


  /* Memes deux modes que sur l'ecran de texte : `contain` garde son cadre
     carre, `cover` passe en pleine hauteur. C'est cette regle partagee qui fait
     que les deux ecrans restent jumeaux, quel que soit le mode retenu. */
  const pleineHauteur = useApercuPleineHauteur() && format?.image?.type !== "contain"
  /* ⚠️ UN SEUL PREDICAT POUR « Y A-T-IL UNE IMAGE ? ». Le fichier en avait
     trois : `format?.image` (l'objet), `format?.image?.link` (l'adresse) et
     `format?.image?.type`. Or l'editeur ecrit `{link:"", type:"cover"}` des que
     l'admin vide le champ d'URL : l'objet existe, l'image non. Tester l'objet
     faisait alors passer l'ecran pour illustre — bande sans hauteur, colonne
     bornee — sans qu'aucune image ne s'affiche. C'est l'adresse qui decide. */
  const aUneImage = !!format?.image?.link
  /* ⛔ 01/10/2026 : `cote` etait la DERNIERE ligne du fichier a tester l'objet
     nu, alors que le commentaire ci-dessus exige l'adresse depuis le 21/09.
     Trouvee par le cliquet `predicat-image-unique`, pas a l'oeil. La declaration
     remonte ici, au-dessus de son premier usage. */
  /* Le cote de l'image alterne d'un ecran a l'autre, regulierement. */
  /* L'alternance n'a de sens que s'il y a une image a faire alterner. Sans
     image, on garde l'ancrage a gauche, toujours le meme. */
  const cote = !pleineHauteur ? null : (aUneImage ? coteDeLImage(actIndex) : "droite")

  /* Meme regle que sur l'ecran de texte, et c'est bien le point : les deux
     ecrans doivent rester jumeaux, avec ou sans image. Un quiz sans image
     recoit le panneau de l'ancien lecteur et conserve la mise en page d'un
     ecran illustre. 55 des 107 quiz de SOFT SKILLS SCAN B1 sont dans ce cas. */
  const panneau = pleineHauteur && !aUneImage
  const commeIllustre = aUneImage || panneau

  /* Lot F (18/09) : variante EXPLICITE du quiz. Absente sur tout l'historique
     => 'qcm' => rendu actuel inchange. Aucune deduction depuis les libelles ni
     depuis le nombre de reponses (cf. FormatsHelpers.quizVariant). */
  const estVraiFaux = quizVariant(format) === QUIZ_VRAI_FAUX

  /* ⛔ 01/10/2026 — LES RACCOURCIS DE LA PLANCHE, ET LEUR REPERE DESSINE.
     Planches 08 et 10 : « 1-4 pour choisir » puis « ↵ pour valider ». Les
     planches Vrai/Faux (09 et 11) ne portent QUE « pour valider » — leurs
     propositions ne sont pas numerotees a l'ecran, donc un chiffre ne
     designerait rien. Le releve des 96 planches le confirme : aucun noeud
     « 1-4 » hors des sections 08 et 10. */
  const nbPropositions = (format?.responses || []).length
  const chiffresUtiles = !estVraiFaux && nbPropositions > 0 && nbPropositions <= 9
  const raccourcisActifs = isEditor !== true && onlyContent !== true
  const reperesClavier = isAlreadyAnswer === true
    ? [{ touche:"entree", libelle: languageValues?.formation?.toucheContinuer?.[actLanguage] }]
    : [
        ...(chiffresUtiles
          ? [{ touche:`1-${nbPropositions}`, libelle: languageValues?.formation?.toucheChoisir?.[actLanguage] }]
          : []),
        { touche:"entree", libelle: languageValues?.formation?.toucheValider?.[actLanguage] },
      ]

  useRaccourciClavier(raccourcisActifs, (e) => {
    /* Un chiffre tape dans un champ reste un chiffre : garde-fou 2 du hook. */
    if (saisieEnCours(e)) return
    if (e.key === "Enter") {
      e.preventDefault()
      if (isAlreadyAnswer === true) { allerAuSuivant(); return }
      if (responses?.length > 0 && envoiEnCours !== true) validQuizz()
      return
    }
    if (isAlreadyAnswer === true || !chiffresUtiles) return
    const rang = Number(e.key)
    if (!Number.isInteger(rang) || rang < 1 || rang > nbPropositions) return
    e.preventDefault()
    handleClick(format?.responses?.[rang - 1], rang - 1)
  })

  /* ⛔ PLUS DE PANNEAU SUR LES ECRANS SANS IMAGE (Hicham, 09/09 : « c'est
     moche quand il y a que du texte »). Le degrade bleu nuit occupait la
     moitie de l'ecran en face d'une colonne de 520 px : sur un ecran qui ne
     porte QUE du texte, cela faisait une page a moitie vide et a moitie
     sombre. Il venait pourtant de l'ancien lecteur — mais chez lui il
     PORTAIT les propositions du quiz ; vide, il ne raconte rien.
     Ce qu'on garde, c'est l'ANCRAGE : le texte reste au meme endroit que sur
     les ecrans illustres, ce qui etait tout l'objet de la regle. Ce qu'on
     rend, c'est la LARGEUR : la colonne passe a la largeur de lecture. */
  const imageDuFormat = !aUneImage ? null
    : pleineHauteur
      ? <Box sx={{ ...imagePleine(cote), backgroundImage:"url(\""+format?.image?.link+"\")", backgroundSize:"cover" }} />
      /* ⛔ IMAGE PORTRAIT DANS UN CADRE, ET C'EST LA PLANCHE QUI LE DIT.
         Node 4:559 : la colonne d'image porte `p-[80px]` et l'image
         `max-w-[480px] max-h-[600px]`, soit un portrait 4:5 qui NE TOUCHE PAS
         le bord de l'ecran. Sur LAB, elle etait carree et collee a x=0 — le lot
         precedent ayant rendu ses marges laterales au conteneur, plus rien ne
         l'ecartait du bord. On lui rend son cadre et son format ici, sans
         toucher a `ImageCarree` que Texte + image utilise, lui, en carre. */
      : <ImageCarree
          lien={format?.image?.link}
          type={format?.image?.type}
          ratio="4 / 5"
          /* Paliers empiles alignes sur LARGEUR_IMAGE (cause A, 21/09) : Mobile
             pleine largeur, Tablet cadre CONTENU — planche 09, image de 320 px
             sur une frame de 834. Desktop inchange. */
          /* Tablet : 320 sur 834 (planches 09 et 10, 4:702), soit 38,4 cqw et
             non 38 (316,9 px, comparateur du 04/10) — la valeur de LARGEUR_IMAGE. */
          largeur={["100%", LARGEUR_IMAGE[1], "min(32cqw, 480px)", "min(32cqw, 480px)"]}
          cadre={["0px", "0px", "0px 40px", "0px 80px"]}
        />

  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      /* ⚠️ `100vh` vaut la hauteur de la FENETRE, jamais celle d'un conteneur.
         Un apercu qui simule 982 px dans un panneau aurait donc affiche un ecran
         calibre sur la vraie fenetre. La variable `--hs-hauteur-ecran` n'est
         definie QUE par le panneau d'apercu ; partout ailleurs le repli `100vh`
         s'applique et rien ne change. Une variable CSS plutot qu'un prop : neuf
         signatures de composants restent intactes, et un format rendu hors du
         lecteur se comporte correctement sans qu'on ait pense a le lui dire. */
      height:onlyContent?"100%":"var(--hs-hauteur-ecran, 100vh)",
      /* ⛔ LE FORMAT DEVIENT SON PROPRE REFERENTIEL DE MESURE (08/09/2026).
         Nawal voit « de grosses differences » entre l'apercu de l'admin et la
         vue apprenant. Cause : l'apercu ne rend pas l'ecran a la taille de la
         fenetre. `ScaleThumbForm` le rend dans une boite FIXE de 1500 x 1000,
         puis la reduit par un `transform: scale()`. Or `vw` et `vh` se
         calculent sur la FENETRE, jamais sur cette boite : les proportions
         divergeaient donc des deux cotes, sans qu'aucun reglage puisse les
         reconcilier — ce sont deux referentiels differents.
         En declarant ce conteneur, les unites `cqw`/`cqh` employees plus bas se
         mesurent sur LUI. Dans le lecteur il occupe la fenetre : le rendu ne
         bouge pas d'un pixel. Dans l'apercu il fait 1500 x 1000 : le rendu
         devient fidele. */
      containerType:"size",
      overflow:"hidden",
      /* ⛔ PAS DE GAP RACINE (22/09). La planche colle le contenu au bandeau :
         le cadre de contenu commence exactement a y=75, et la bande basse est
         adjacente elle aussi. Ces 10 px repoussaient tout l'ecran vers le bas et
         comptaient pour 10 des 22 px de decalage mesures sur la pastille. */

      position: APERCU_EDITO ? "relative" : "static",
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <QuizzHelper
            format={format}
          />
        </EditorPopover>
      }
      { /* END EDITOR ADMIN */}
      <TopBar
        actFormation={actFormation}
        actIndex={actIndex}
        setViewPlanCours={setViewPlanCours}
        viewPlanCours={viewPlanCours}
        onlyContent={onlyContent}
      />
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
        /* ⛔ L9 EST REMPLACEE PAR LE FIGMA DU 17/09, ET C'EST TRACE.
           L9 (Valentin, 13/05/2026) disait « Retirer l'element au-dessus des
           questions ». C'est une preference purement VISUELLE, sans regle de
           comportement, du meme auteur que les planches, et anterieure de
           quatre mois. Les planches actuelles montrent la pastille de
           sous-chapitre sur CHAQUE ecran de question — quiz 3:282231,
           questionnaire 3:241965, saisie 3:40519, quiz illustre 4:559.
           Regle appliquee : a preference visuelle egale, la source la plus
           recente du meme auteur l'emporte. */
        noPartInfos={false}
        cote={cote}
        /* ⛔ LOT H — LES MARGES LATERALES CHANGENT DE PLACE, ELLES NE DISPARAISSENT PAS.
           Figma ne met aucune marge sur la zone de contenu : il en met 40 px sur
           la zone haute et 60 px sur la bande. Tant que les 170 px vivaient sur
           le conteneur, la bande ne pouvait pas atteindre les bords sans un
           artifice geometrique — et le lot G a prouve, trois fois, qu'aucun de
           ces artifices ne tient. On les rend donc au conteneur et on les repose
           la ou la planche les met.
           ⚠️ Par un DRAPEAU, pas par un `sx` : un longhand pose par-dessus le
           raccourci responsive de MUI est ecrase par lui, et silencieusement. */
        sansMargesLaterales
        /* ⛔ DECISION D'HICHAM DU 03/10/2026 (PD-23) : LE QUIZ SUIT LA MAQUETTE.
           La zone haute de la planche part en haut, a distance fixe de
           l'en-tete : `pt-[120px]` sur 3:302251 (Desktop), pastille a 162 px de
           l'en-tete en Tablet (3:382627) et a 51 en Mobile (3:382572, rendu).
           Le code posait 48, 32 et 24.
           ⚠️ LA VALEUR DE LA PLANCHE SEULEMENT A LA HAUTEUR DE LA PLANCHE.
           Premier jet : un plafond proportionnel (`min(120px, 12.2cqh)`). La
           relecture de code l'a releve, la mesure l'a confirme : il ne cedait
           presque pas, et a 1440x790 on ne voyait plus que 2 reponses sur 4
           (3 avant). Desormais : la valeur de la planche quand l'ecran est au
           moins aussi haut qu'elle (982, 1194, 796), puis le retrait diminue
           pixel pour pixel jusqu'a l'ancienne valeur, jamais en dessous. Sous
           la hauteur de la planche, l'ecran redevient celui d'avant.
           Choix multiple sans image seulement : la planche illustree (4:569)
           part sous l'en-tete, et le Vrai/Faux n'a pas de planche controlee. */
        retraitHaut={aUneImage ? undefined : (estVraiFaux ? RETRAIT_VRAI_FAUX : RETRAIT_QUIZ)}
              pastilleDansColonne
              pastilleAvecImage={aUneImage}
      >
        {({ pastille }) => (<>
        {/* ⛔ ALIGNEMENT COMMUN (Nawal, 08/09) : « la position des textes varie
            trop et perd le user ». Mesure a 1440x900 entre deux ecrans qui se
            ressemblent, Texte+image et Quizz+image : l'image se decalait de
            56 px, la colonne de texte de 22 px, sa largeur variait de 77 px,
            et le haut de l'image de 21 px. Pire, a 1180 px de large l'ecran
            Texte etait EN DEUX COLONNES quand le quiz etait encore empile :
            deux ecrans jumeaux, deux mises en page differentes.
            Cause unique : deux implementations d'un meme motif. Le quiz ne
            recopie donc plus les reglages de `BlocIllustre`, il l'UTILISE.
            Un seul endroit fait foi ; toute divergence future est impossible
            par construction. Ce qui reste ici est ce que le quiz seul exige :
            occuper la hauteur restante et confiner son debordement. */}
        <BlocIllustre
          pastille={pastille}
          sx={{
            /* ⛔ La hauteur ne peut pas etre un nombre magique. `calc(100vh - 260px)`
               supposait des bandeaux de hauteur fixe : le bloc descendait sous
               la barre du bas, et la derniere proposition du quiz s'y trouvait
               tranchee. Sans barre de defilement visible sur macOS, rien ne
               l'indiquait : l'apprenant pouvait repondre sans l'avoir lue.
               `flex: 1` prend exactement la place que le conteneur central
               laisse. `minHeight: 0` est indispensable : sans lui, un enfant en
               overflow refuse de retrecir dans un parent flex. */
            /* ⛔ 04/10/2026 — EMPILE ET ILLUSTRE, LA PAGE DEFILE (B84). Avec
               image, aux paliers empiles, le bloc se comprimait a la hauteur de
               l'ecran et rognait sa bande en `overflow: hidden` : sur un iPhone
               SE (320 x 568) ou un telephone en paysage (667 x 375), le bouton
               Valider restait hors de portee du doigt (deja vrai sur LAB ;
               relecture de code du 04/10, contre-epreuve a la molette). Les
               planches 09 et 10 sont d'ailleurs plus hautes que l'ecran (4:338,
               4:625) : la page defile. Mobile : le bloc suit son contenu ; Tablet : il
               remplit l'ecran sans se comprimer ; en deux colonnes, inchange. */
            flex: aUneImage ? ["0 0 auto", 1, 1, 1] : 1,
            minHeight: aUneImage ? ["auto", "auto", 0, 0] : 0,
            /* Lot H : retour au confinement simple. Le lot G avait du ouvrir
               l'axe horizontal (`overflowX:visible` + `overflowY:clip`) parce que
               la bande teintee debordait de ce bloc pour atteindre les bords de
               l'ecran. Elle n'en deborde plus : les marges laterales ont ete
               rendues au conteneur et la bande est un bloc pleine largeur, comme
               sur la planche. Le contournement n'a plus d'objet, et une regle qui
               n'a plus d'objet se retire. */
            overflow: aUneImage ? ["visible", "visible", "hidden", "hidden"] : "hidden",
            /* Fenetre courte : deux colonnes au palier Tablet ; on garde le
               comportement des grands paliers (relecture du 04/10 : sinon
               Valider quittait le premier ecran a 1024 x 640). */
            /* B85 (04/10) : `auto` en vertical et non `hidden`, par securite.
               La pastille est desormais AU-DESSUS de la question (elle etait a
               cote, en troisieme colonne) et coute 51 px ; si la colonne ne
               tient plus, le bloc defile de ce qui manque au lieu de rogner
               Valider. Sous 450 px de haut la pastille s'efface
               (FENETRE_TRES_BASSE) et tout tient comme sur `a79d613` : mesure a
               800 x 360, Valider de 280 a 330 dans les deux versions. */
            ...(aUneImage ? { [FENETRE_COURTE]: { flex:1, minHeight:0, overflowX:"hidden", overflowY:"auto" } } : {}),
          }}
          image={imageDuFormat}
          horsFlux={cote}
        >
          {/* ⛔ LE FONDU. Sa fiche V2 tranche : « une barre visible a
              l'interieur du bloc qui deborde ». Sur macOS, la barre de
              defilement est MASQUEE au repos : elle n'apparait qu'une fois
              qu'on defile, donc exactement quand on n'a plus besoin d'etre
              prevenu. Mesure au banc sur huit tailles de fenetre : a 1440x790,
              1280x700 et 1024x640, des propositions sortent du cadre. La barre
              seule ne les signale pas.
              Le degrade, lui, se voit au repos. Il est pose sur un conteneur
              QUI NE DEFILE PAS : dans le bloc defilant il glisserait avec le
              contenu et ne marquerait plus le bord.
              ⚠️ En attente de validation de Nawal : c'est un ajout de ma part,
              pas une demande de la fiche. */}
          <Box sx={{
            position:"relative",
            display:"flex",
            flexDirection:"column",
            minHeight:0,
            /* Bornee a tous les paliers, y compris quand tout est empile :
               c'est ce qui permet a la colonne de defiler au lieu de perdre
               ses dernieres propositions. */
            /* ⛔ LOT H — ECRAN ILLUSTRE : LA COLONNE REMPLIT JUSQU'AU BORD.
               Node 4:559 : la photo occupe 691 px a gauche et la colonne de
               contenu les 821 px restants, c'est-a-dire JUSQU'AU bord droit de
               l'ecran ; sa bande (4:569) occupe toute cette largeur, et la
               moitie de la photo reste blanche.
               Le lot G avait essaye d'y arriver en faisant deborder la bande
               hors d'une colonne bornee a 560 px. Trois tentatives, trois
               echecs mesures. La vraie reponse n'etait pas geometrique : c'est
               la COLONNE qui doit remplir, pas la bande qui doit deborder.
               ⚠️ Cet ecran ne partage donc plus ses proportions avec Texte +
               image. C'est voulu : la planche leur donne des compositions
               differentes, l'une portant une bande et l'autre pas. */
            /* ⛔ `width:"100%"`, JAMAIS `auto`. En apercu editorial, `cote` est
               renseigne et `BlocIllustre` passe en `column` + `flex-start` : sur
               l'axe transversal, `auto` vaut alors FIT-CONTENT, et la bande
               prenait la largeur de la reponse la plus longue — 423 px mesures a
               1512 pour quatre reponses courtes, la moitie droite de l'ecran
               restant blanche. `flex:1` n'y change rien, il agit sur l'axe
               principal, qui est vertical dans ce mode.
               `100%` remplit le conteneur en colonne, et se fait battre par
               `flex-basis:0` en rangee : la colonne y prend le reste, ce que la
               planche 4:559 demande. Un seul mot pour les deux modes. */
            width:"100%",
            /* Lot H : la colonne n'est plus bornee. Elle porte desormais DEUX
               zones de largeurs differentes — l'enonce, borne a 1000 px, et la
               bande, qui va d'un bord a l'autre. Borner la colonne bornerait la
               bande avec elle. Chaque zone porte donc sa propre largeur. */
            maxWidth:"100%",
            /* ⚠️ `flex: 1` doit s'arreter ou commence la double colonne, sinon
               la colonne grandit HORIZONTALEMENT au-dela de LARGEUR_CONTENU et
               l'alignement qu'on vient de retablir se defait. La bascule est
               celle de `BlocIllustre` : deux colonnes des « md ». */
            /* Lot H : sans image, la colonne EST la zone de contenu de Figma —
               elle prend toute la hauteur et repartit `space-between`, l'enonce
               en haut et la bande en bas. Avec image, on garde le comportement
               d'avant : `flex` s'arrete ou commence la double colonne, sinon la
               colonne grandit horizontalement au-dela de sa largeur. */
            flex:1,
            justifyContent:"space-between",
            ...(commeIllustre ? COLONNE_ILLUSTREE : {}),
            /* ⚠️ DEUX LARGEURS. Face a une image, la colonne tient dans sa moitie
               (520 px). Sans image, elle n'a plus de voisine : la maintenir a
               520 px laissait un ecran a moitie vide, ce qu'Hicham a trouve
               moche « quand il y a que du texte ». Elle passe alors a la
               largeur de lecture, en gardant le meme bord gauche : le texte ne
               bouge pas, il respire. */
            /* ⚠️ Cette largeur d'apercu ne s'applique plus qu'aux ecrans qui ont
               REELLEMENT une image. Sans cette garde, un quiz sans image vu en
               apercu editorial voyait sa colonne — et donc sa bande — bornee a
               720 px et ferree a gauche, alors que la planche la veut pleine
               largeur. Elle est posee en `@media`, donc elle ecrasait le
               `width` de quelques lignes plus haut sans qu'on le voie. */
            ...(pleineHauteur && aUneImage ? { width:["100%", "100%", "min(38cqw, 520px)", "min(38cqw, 520px)"], maxWidth:"100%",
                                  position:"relative", zIndex:1 } : {}),
          }}>
          {/* ⛔ LA QUESTION NE DOIT PAS DEFILER (constat du 08/09, banc a
              1440x900). Elle etait dans le bloc defilant avec les propositions.
              Apres validation, l'explication s'ajoute, le bloc deborde, et la
              question sort par le haut : mesure, son sommet tombait a -49 px.
              L'apprenant voyait alors des reponses colorees et un commentaire
              sans plus savoir ce qu'on lui avait demande.
              Elle est desormais posee AU-DESSUS du bloc defilant. Seules les
              propositions et l'explication defilent ; l'enonce reste sous les
              yeux du debut a la fin.
              ⚠️ LA SECONDE MOITIE DE CETTE REGLE EST ANNULEE DEPUIS LE LOT H.
              Elle posait `flexShrink: 0` pour que l'enonce ne soit jamais
              comprime. Depuis que la bande porte aussi le bouton de validation,
              deux blocs incompressibles font sortir le bas de l'ecran du cadre.
              L'enonce cede donc maintenant — voir le bloc detaille au ras du
              code. Ce qui reste vrai, et qui etait l'essentiel : l'enonce ne
              defile PAS avec les propositions, il reste a l'ecran. */}
          <Box sx={{
            /* ⚠️ COMPRESSIBLE, ET CELA ANNULE LA REGLE DU 08/09 ECRITE CI-DESSUS.
               Elle posait `flexShrink:0` pour que l'enonce reste entier sur une
               fenetre courte. Mais depuis que la bande porte aussi le bouton de
               validation, deux blocs incompressibles font sortir le BAS de
               l'ecran du cadre : l'apprenant ne peut plus valider. Entre un
               enonce qui se comprime et un bouton qu'on ne peut plus atteindre,
               le choix n'est pas discutable — mais il se dit, il ne se glisse
               pas.
               ⛔ ET S'IL DEFILE, IL LE SIGNALE — A MOITIE, ET C'EST DIT.
               Il recoit la barre fine de `BLOC_DEFILANT`. Il ne recoit PAS de
               fondu : `FonduBas` se pose sur un conteneur qui ne defile pas, et
               celui-ci defile. Or sur macOS la barre est masquee au repos, ce
               que ce fichier documente en douze lignes plus bas. Le signal est
               donc incomplet sur cette plateforme, et c'est un ecart assume
               plutot qu'une phrase qui promettrait un fondu absent.
               ⚠️ La bande cede AVANT l'enonce (`flexShrink` 2 contre 1) : c'est
               elle qui a un bloc defilant fait pour ca. */
            /* ⛔ 06/10/2026 (Nawal, capture LAB, ICEBREAKER DEMO valentin) :
               APRES UNE REPONSE AVEC EXPLICATION, LA BANDE NE MONTE JAMAIS SUR LA
               CONSIGNE. Dans ce cas la bande epouse son contenu (exception du
               04/10, `hauteur` « auto ») ; avec beaucoup de choix longs et une
               explication longue, les deux blocs cedaient en proportion de leur
               taille, et l'enonce, plus petit, perdait sa consigne (« Une seule
               réponse » coupee ou masquee : mesure a 1512, 4 px visibles sur 30).
               Desormais, dans ce seul etat, la bande cede la PREMIERE, jusqu'a
               son plancher, et son contenu defile en elle ; « Suivant », dans la
               rangee de controles, reste visible. L'enonce ne cede qu'ensuite, si
               la fenetre est vraiment trop basse (meme regle qu'avant). Et 40 px
               au moins (20 en Mobile) separent la consigne du haut de la bande,
               l'ecart de la planche 08d (3:342425 : 49 px entre la consigne et la bande, interligne compris). Sans
               explication, rien ne change. */
            flexShrink: explicationVisible ? 0.0001 : 1,
            /* (pas en pile avec image : la page y defile deja, B84, et la marge
               y deplacait l'enonce sans rien proteger) */
            ...(explicationVisible ? { marginBottom: aUneImage ? ["0px", "0px", "40px", "40px"] : ["20px", "40px", "40px", "40px"] } : {}),
            minHeight:0,
            /* ⛔ 04/10/2026 — B87 : SUR UNE FENETRE BASSE, UNE LIGNE AU MOINS.
               Compressible jusqu'a 0, l'enonce tombait a 5 px visibles a
               800 x 360 (quiz illustre) : on ne lisait plus la question sans
               penser a faire defiler son cadre. Sous 500 px de haut, il garde
               une ligne entiere (21,5 a 25 px de texte + la reserve des accents, 6 a 10) ;
               la bande, qui defile, cede a sa place, et le bloc defile s'il le
               faut (`fenetres-courtes.mjs`, regle 3). */
            "@media (max-height:500px)": { minHeight:"36px" },
            ...BLOC_DEFILANT,
            overflowY:"auto",
            ...RESERVE_ACCENTS,  /* place au-dessus de l'enonce rogne : voir FormatsHelpers */
            /* Figma, zone haute : `max-w-[1000px]` centre, `px-[40px]`. La
               largeur vivait sur la colonne ; elle vit maintenant ici, ou la
               planche la met. */
            width:"100%",
            /* 1000 px de TEXTE, marges en plus : la planche pose la question a
               1000 de large (3:302257) ; borne a 1000 marges comprises, elle en
               faisait 920 et passait de deux a trois lignes. */
            maxWidth:`calc(${LARGEUR_QUESTION} + ${2 * MARGE_QUESTION}px)`,
            alignSelf:"center",
            paddingLeft:["25px", `${MARGE_QUESTION}px`, `${MARGE_QUESTION}px`, `${MARGE_QUESTION}px`],
            paddingRight:["25px", `${MARGE_QUESTION}px`, `${MARGE_QUESTION}px`, `${MARGE_QUESTION}px`],
            boxSizing:"border-box",
          }}>
            <EditableField
              field={sansBlancsAutour(format?.questions)}
              type="questions"
              isEditor={isEditor}
              sx={{
                color:"text.black",
                /* Sur une fenetre courte, la question mangeait la place des
                   propositions : elle cede du terrain avant elles. La borne
                   haute reste celle de la maquette. */
                /* ⚠️ ECHELLE DU TITRE RELUE DANS FIGMA (21/09/2026, lot 3a).
                   Jeton nomme « Text/Desktop/Heading/H1 » : Questrial Regular,
                   42 px, interligne 1,15, letterSpacing 0. Noeuds 3:302257
                   (Desktop), 3:282076 (Tablet), 3:282135 (Mobile, 26 px / 1,25).
                   Le 46 px du palier lg etait estime : la planche s'arrete a 42.
                   L'interligne n'etait declare NULLE PART, donc le navigateur
                   retombait sur `normal`, soit environ 1,15 a 1,2 selon la
                   police. On le pose explicitement. */
                /* 04/10/2026 : 38 px sur la planche ILLUSTREE (4:567), ou
                   l'enonce n'a que 741 px, aux grands paliers. */
                fontSize: aUneImage ? ["26px", "min(42px, 5.2cqh)", "min(38px, 5.2cqh)", "38px"] : ["26px", "min(42px, 5.2cqh)", "min(42px, 5.2cqh)", "42px"],
                lineHeight:["1.25", "1.15", "1.15", "1.15"],
                ...ROGNE_HAUT,  /* haut des capitales, comme la maquette : voir FormatsHelpers */
                textAlign:"center", // Lot B : titre/sous-titre centre meme avec image (frames « Claude »)
              }}
            />
            {/* Point 11 : le mode de selection est annonce dans les DEUX cas.
                Il ne l'etait que pour le choix multiple, ce qui laissait
                l'apprenant deviner. Pas de mention sur un quiz sans bonne
                reponse : il n'y a alors rien a choisir au sens propre. */}
            {/* ⛔ 30/09/2026 — FICHE DE RETOUR DE NAWAL, POINT 6. La regle
                ci-dessus etait trop large et Nawal l'a prise en flagrant delit :
                sur une question a la fois « choix multiple » ET « sans bonne
                reponse », la mention disparaissait, et l'apprenant ne savait
                plus qu'il pouvait cocher PLUSIEURS cases. Or « il n'y a rien a
                choisir » ne vaut que pour le nombre de reponses ATTENDUES ; le
                nombre de reponses PERMISES, lui, reste une information dont
                l'apprenant a besoin pour agir.
                On garde donc le silence sur « Une seule reponse » quand il n'y
                a pas de bonne reponse (rien de neuf a dire), et on annonce
                toujours le choix multiple. */}
            {(format?.multi === true || format?.noValidAnswer !== true) &&
              <Box sx={{
                /* Mesure au comparateur (03/10/2026) contre l'ecart de la planche
                   entre la question et la consigne : 40 en Desktop et Tablet
                   (3:302256, 3:382632), 20 en Mobile (3:382577), une fois les
                   deux textes rognes. Tablet rendait 35, Mobile 23,6. */
                marginTop:["6px", "20px", "20px", "20px"],
                textAlign:"center", // Lot B : titre/sous-titre centre meme avec image (frames « Claude »)
                color:"text.subTitle",
                /* ⚠️ CONSIGNE RELUE DANS FIGMA (21/09/2026, lot 3a). Jeton
                   « Text/Desktop/Body/Large » : 20 px, interligne 1,5, aux deux
                   grands paliers ; 15 px en Mobile (3:282136). Cinq formats
                   portaient cinq echelles differentes pour le MEME element. */
                  fontSize:["15px", "20px", "20px", "20px"],
                  lineHeight:"1.5",
              }}>
                {format?.multi === true
                  ? languageValues?.formation?.multipleAnswers?.[actLanguage]
                  : languageValues?.formation?.singleAnswer?.[actLanguage]}
              </Box>
            }
          </Box>
            {/* ⛔ L11 DE LA REVUE VALENTIN, « combler le vide qui apparait au
                scroll ». La cause : ce bloc etait centre par `margin: auto 0`
                dans un parent qui defile. Des que le contenu depasse, des
                marges automatiques se figent au-dessus et en dessous : on
                defile alors dans du vide, et le haut du contenu devient meme
                inatteignable, c'est un comportement connu du modele flex.
                `justify-content: safe center` fait exactement ce qu'on veut :
                centre tant que ca tient, s'ancre en haut des que ca deborde.
                Le mot-cle `safe` est ce qui evite le vide ; ne pas le retirer. */}
          <BandeReponse
                calerEnBas={aUneImage}
            reperes={reperesClavier}
            /* Hauteurs relevees au node : 444 px pour le QCM et ses quatre
               cartes (3:302259), 400 px pour le Vrai/Faux (6:309). Ecran
               illustre : la planche 4:569 ne fixe aucune hauteur, la bande y
               epouse son contenu. */
            /* ⚠️ `format?.image` ET NON `commeIllustre`. `commeIllustre` est
                vrai pour TOUT quiz vu en apercu editorial, image ou pas : les
                hauteurs relevees au node n'y etaient donc jamais posees, et le
                mode qui sert justement a valider le redesign montrait autre
                chose que le redesign. Ce qui decide, c'est la presence d'une
                image — la planche 4:569 est la seule ou la bande epouse son
                contenu. */
            /* Vrai/Faux illustre : bande de 400 px en Desktop, comme sans
               image (4:444, 04/10/2026). */
            /* ⛔ 04/10/2026 : APRES LA REPONSE, AVEC UNE EXPLICATION, LA BANDE
               EPOUSE SON CONTENU. A 444 px (400 en Vrai/Faux), l'explication
               « Bonne reponse » passait sous les cartes, dans la zone qui
               defile : on ne la voyait pas sans y penser. La planche 3:342425
               laisse la bande grandir vers le haut (de 537 a 453) et montre
               tout. Le plancher reste celui de la planche. */
            /* ⛔ 06/10/2026 — REVIEW DE NAWAL DU 5 OCT, POINT 1.3 (tranche par
               elle) : QCM, AVEC OU SANS IMAGE, BANDE DE 444 PX EN DESKTOP ET EN
               TABLET, comme le questionnaire. La bande ne grandit plus avec les
               reponses : elles defilent DANS la box (bloc `refDefilant`, avec
               son fondu). Avant : avec image, la bande epousait son contenu
               (437 px a 4 reponses, plus avec 6) ; sans image, en Tablet, elle
               grandissait aussi (583 px a 6 reponses longues). Mobile : inchange
               (la page defile, pas de defilement imbrique), Nawal n'a pas
               tranche. Vrai/Faux : inchange (hors du point).
               Le plafond proportionnel (46 % de la hauteur) et le plancher
               restent : sur une fenetre basse, la bande cede comme avant.
               ⚠️ L'EXCEPTION D'APRES-REPONSE EST GARDEE (04/10, ci-dessus) : avec
               une explication, la bande epouse encore son contenu. A confirmer
               par Nawal. */
            hauteur={explicationVisible ? "auto" : (estVraiFaux ? "400px" : "444px")}
            hauteurMin={estVraiFaux ? "400px" : (aUneImage ? "0px" : "400px")}
            /* Vrai/Faux : cartes a 40 px du haut de la bande (6:309, 4:444), bande
               de 400 px en Tablet sans image (34:1298), de la hauteur de son
               contenu avec image (228 px, 4:412) et en Mobile (180 px, 34:1318). */
            {...(estVraiFaux ? { hautGrand: aUneImage ? [30, 40, 40] : 40, plancherMobile: "min(180px, 46cqh)",
                                 ...(aUneImage ? { plancherTablette: "min(228px, 46cqh)" } : { hauteurFixeTablette: true }) }
                             : { hauteurFixeTablette: true })}
            /* 40 px entre cartes et controles, avec ou sans image, QCM ou
               Vrai/Faux (3:302259, 4:570, 4:412), a la hauteur de la planche. */
            ecart={ECART_QUIZ}
            /* Illustre en Mobile, la page defile : 60 px sous la consigne
               (planches 09 et 10, `pb-60` de la zone haute : 4:340, 4:627). */
            sousConsigneMobile={aUneImage}
            onlyContent={isEditor ? false : onlyContent}
            controles={
              <>
                {/* 27/09/2026 : l'envoi au serveur a echoue (candidat THE SCAN).
                    L'ecran reste non repondu ; le bouton reste la pour
                    reessayer. `role="alert"` pour qu'un lecteur d'ecran
                    l'annonce. */}
                {isAlreadyAnswer === false && echecEnvoi &&
                  <Box role="alert" sx={{
                    flex:1,
                    marginRight:["12px", "20px", "20px", "20px"],
                    color:"text.black",
                    fontSize:["14px", "15px", "16px", "16px"],
                    lineHeight:1.4,
                    textAlign:"left",
                  }}>
                    {t(languageValues?.formation?.reponseNonEnregistree)}
                  </Box>
                }
                {isAlreadyAnswer === false &&
                  <EditableButton
                    isEditor={false}
                    disabled={responses?.length === 0 || envoiEnCours}
                    type="button"
                    field={format?.noValidAnswer ? languageValues?.continue[actLanguage] : languageValues?.validate[actLanguage]}
                    sx={{}}
                    onClick={validQuizz}
                  />
                }
                {isAlreadyAnswer === true &&
                  <EditableButton
                    isEditor={false}
                    type="button"
                    /* « Suivant » apres la reponse, comme la planche (3:362474,
                       33:477) et comme le texte et la video (PD-21) : tranche par
                       Hicham le 04/10/2026 (PD-30). */
                    field={languageValues?.next[actLanguage]}
                    sx={{}}
                    onClick={() => { if (isEditor !== true) { allerAuSuivant() } }}
                  />
                }
              </>
            }
          >
          <Box ref={refDefilant} sx={{
            flex:1,
            minHeight:0,
            /* ⛔ ARBITRAGE DE NAWAL, fiche V2 : « pas de barre de scroll sur
               la PAGE, mais une barre visible A L'INTERIEUR du bloc qui
               deborde ». Il remplace la demande L10 de juin (« retirer la
               barre quand les reponses debordent »), qu'elle tranche
               explicitement en faveur de la decision de la vague 1.
               Mesure au banc, 1440x900 : sans barre, la quatrieme proposition
               d'un quiz sortait du cadre sans le moindre signe. L'apprenant
               pouvait repondre sans l'avoir lue. */
            ...BLOC_DEFILANT,
            /* ⛔ 03/10/2026 — LA RESERVE DE LA BARRE, COMPTEE UNE SEULE FOIS.
               `BandeReponse` rend deja ses 4 px a son bloc defilant ; celui-ci
               en reprenait 4 sur les cartes : 746 au lieu des 750 de la planche
               (3:302261), 710 au lieu de 714 en Tablet. Meme remede : le bloc
               s'elargit de sa reserve et la fait passer dans la marge. */
            width:`calc(100% + ${BLOC_DEFILANT.paddingRight})`,
            marginRight:`-${BLOC_DEFILANT.paddingRight}`,
            overflowX:"hidden",
            /* garde le point precedent : rien ne defile sous le grand ecran,
               ou la colonne n'est pas bornee en hauteur */
            overflowY:"auto",
            display:"flex",
            flexDirection:"column",
            justifyContent:"safe flex-start", // ancre en haut, cf. BandeReponse
            /* Ce bloc ne porte plus ni teinte ni debordement : il n'est que la
               partie DEFILANTE de la bande. `BandeReponse` tient la teinte, la
               hauteur et les marges — voir son commentaire pour ce que Figma
               encode exactement. */
          }}>
            <Box sx={{
              /* ⛔ PLUS DE MARGE HAUTE DANS LE BLOC DEFILANT. La bande porte deja
                 son `py-30` ; ces 50 px s'ajoutaient DANS la zone defilante et
                 mangeaient la place des cartes. Mesure a 1512x982 avec les quatre
                 reponses de la planche : 314 px visibles pour 352 px de contenu,
                 la quatrieme carte coupee a plus de moitie alors que la bande
                 faisait bien ses 444 px. La hauteur etait juste, le contenu n'y
                 tenait pas. */
              marginTop:0,
              display:"flex",
              flexDirection:"column",
              gap:["11px", "14px", "14px", "19px"],
              userSelect:"none",
              alignItems:commeIllustre ? ["center", "center", "center", "flex-start"] : "center",
            }}>
              {/* Lot F (18/09) : en variante Vrai/Faux, les deux choix se posent
                  COTE A COTE, a largeurs egales (frames « Claude » 09 et 10-11).
                  Le QCM garde la liste verticale.
                  ⛔ LES CHOIX ONT LEUR PROPRE CONTENEUR, et ce n'est pas cosmetique :
                  le bloc « Bonne/Mauvaise reponse » est un FRERE des cartes. Tant que
                  la direction `row` etait portee par le conteneur commun, l'explication
                  (width 100%) se posait sur la MEME ligne que les boutons et, ceux-ci
                  etant en `flex:1 minWidth:0`, les ecrasait a 0 px : l'apprenant ne
                  voyait plus ni son choix ni la bonne reponse. */}
              <Box sx={{
                display:"flex",
                flexDirection: estVraiFaux ? "row" : "column",
                /* ⚠️ VALEURS RELEVEES SUR LE NODE 3:302259, PAS CHOISIES.
                   Cartes : premiere a y=0, seconde a y=76, hauteur 66 -> l'ecart
                   est de 10 px, pour le QCM comme pour le Vrai/Faux. J'avais
                   d'abord « retabli » 19 px en croyant reparer une regression :
                   c'est la mesure qui tranche, pas la memoire du lot precedent.
                   Largeur : 750 px, et non la largeur de lecture du texte
                   (720 px) — la colonne des cartes est plus large que la colonne
                   de texte, c'est voulu sur la planche. */
                gap: estVraiFaux ? ["15px", "17px", "17px", "17px"] : "10px",   /* 17 px entre les deux cartes Vrai/Faux ; le 10 px du QCM est correct et reste */
                width:"100%",
                maxWidth: LARGEUR_CARTES,
                alignSelf:"center",
                alignItems: estVraiFaux
                  ? "stretch"   // les deux boutons ont la meme hauteur
                  : (commeIllustre ? ["center", "center", "center", "flex-start"] : "center"),

              }}>
              {format?.responses?.map((item, i) => {
                let statut = ""
                let findInReps = responses.find((el) => el === i)
                if (isAlreadyAnswer) {
                  if (format?.noValidAnswer !== true) {
                    if (item?.isValid) { //c'est une bonne réponse
                      if (findInReps !== undefined) {
                        //good, sélectionné et bonne réponse (vert)
                        statut = "good"
                      } else {
                        //pas good, pas sélectionné et bonne réponse (orange)
                        statut = "mustBeSelected"
                      }
                    } else { //c'est une mauvaise réponse
                      if (findInReps !== undefined) {
                        //pas good, sélectiooné et mauvaise réponse (rouge)
                        statut = "wrong"
                      }
                    }
                  } else {
                    if (findInReps !== undefined) {
                      statut = "selected"
                    }
                  }
                } else {
                  if (findInReps !== undefined) {
                    statut = "selected"
                  }
                }

                /* Figma : la carte au repos porte une bordure claire #E8E8E8
                   (au lieu de transparente = invisible), et le badge vide est un
                   carre blanc borde. Les couleurs d'ETAT (vert/orange/rouge)
                   restent la logique de validite, inchangees. */
                let border = "1px solid #E8E8E8"
                let background = "white"
                let iconBg = "white"
                if (statut === "selected") {
                  border = "1px solid black"
                  background = "white"
                  iconBg = "black"
                } else if (statut === "good") {
                  border = "1px solid #53D769"
                  background = "#eefbf0"
                  iconBg = "#53D769"
                } else if (statut === "mustBeSelected") {
                  /* ⚠️ 21/09/2026 : le node dit #FED030, pas #FED64A. Releve
                     sur 3:362460 (Desktop) et 13:695 (Mobile). Le « jeton Figma
                     2026 » invoque par le commentaire precedent n'a pas ete
                     retrouve dans le fichier. Le meme #FED64A reste pose dans
                     theme/index.js (palette.feedback.warn) : je ne touche pas au
                     jeton, ses autres usages n'ayant pas de planche pour
                     arbitrer. ⚠️ A reconcilier. */
                  border = "1px solid #FED030"
                  background = "#fffae9"
                  iconBg = "#FED030"   /* aligne sur le jeton reconcilie */
                } else if (statut === "wrong") {
                  border = "1px solid #FC3040"
                  background = "#ffeaec"
                  iconBg = "#FC3040"
                }
                // Lot E (18/09) : en resultat, une reponse NON choisie et neutre
                // recoit un badge GRIS a tiret (frames quiz Figma « Claude »).
                // Gris soutenu (#9E9E9E) pour que le tiret BLANC reste lisible ;
                // #E0E0E0 le rendait quasi invisible (contraste ~1.3:1).
                // ⚠️ QCM uniquement : en Vrai/Faux les frames ne montrent AUCUN
                // badge sur la reponse neutre non choisie.
                if (!estVraiFaux && isAlreadyAnswer && statut === "") { iconBg = "#9E9E9E" }
                /* Lot F : en Vrai/Faux le badge n'apparait QUE s'il dit quelque
                   chose (choix en cours, ou resultat). Au repos, les deux boutons
                   sont nus. En QCM le badge est toujours la (il porte le numero). */
                const afficherBadge = estVraiFaux ? (statut !== "") : true
                return (
                  <Box
                    key={i}
                    onClick={() => {
                      handleClick(item, i)
                    }}
                    sx={{
                      border:border,
                      cursor:isAlreadyAnswer?"default":"pointer",
                      background:background,
                      display:"flex",
                      alignItems:"center",
                      // L6 : bordure noire au survol tant qu'on n'a pas valide
                      "&:hover" : {
                        borderColor: isAlreadyAnswer ? undefined : "black",
                      },
                      /* Vrai/Faux : deux boutons a largeur egale, texte centre,
                         badge ancre a gauche SANS decaler le texte (position
                         absolue) — c'est ce que montrent les frames.
                         QCM : liste verticale, badge puis texte dans le flux. */
                      ...(estVraiFaux ? {
                        flex:1,
                        minWidth:0,
                        position:"relative",
                        justifyContent:"center",
                        minHeight:["60px", "78px", "78px", "78px"]   /* carte Vrai/Faux : 78 px sur les planches */,
                      } : {
                        width:"100%",
                        gap:"15px",
                        /* ⛔ 03/10/2026 — 66 px DE HAUT, BORDURE COMPRISE, sur une
                           ligne comme sur deux (3:302261 et 3:302265 : 66 tous les
                           deux). Figma pose 12 px de marge AVEC le trait a
                           l'interieur ; le navigateur ajoutait le trait aux 12 :
                           une carte de deux lignes faisait 67,4, et avec les 40 px
                           de la planche entre cartes et bouton, la quatrieme carte
                           perdait sa bordure basse (photos du 03/10). Mobile :
                           aucun ecart releve, il garde ses 12. */
                        padding:["12px 20px 12px 12px", "11px 20px 11px 12px", "11px 20px 11px 12px", "11px 20px 11px 12px"],
                        minHeight:["auto", "66px", "66px", "66px"],
                        /* ⛔ 01/10/2026 — `border-box`, ET C'EST LE POINT 4
                           D'HICHAM (« format quiz : avec image ma faite regarde
                           capture »).
                           La carte etait en `content-box` : ses 12 + 20 px de
                           marge interieure et ses 2 px de bordure s'AJOUTAIENT
                           au `width:100%`. Mesure a 1512 sur `quiz-image` :
                           cartes larges de 731 dans un bloc de 697, debordant de
                           34 px a droite — donc desalignees avec le bouton
                           Valider, qui s'arrete lui a 1452.
                           La planche 10 donne 701 de large pour 66 de haut
                           (node 4:572), soit exactement la largeur du bloc.
                           Le filet ne pouvait pas le voir : il compare chaque
                           ecran a sa propre photo d'avant, et ce debordement y
                           etait des la premiere photo. */
                        boxSizing:"border-box",
                      }),
                    }}
                  >
                    {/* Lot E (18/09) : indicateur a GAUCHE (frames quiz Figma
                        « Claude »). Pendant le choix il porte le NUMERO (1-N) ;
                        une fois valide, l'icone d'etat (check / croix / tiret). */}
                    {afficherBadge &&
                    <Box sx={{
                      display:"flex",
                      alignItems:"center",
                      /* Vrai/Faux : ancre a gauche, hors flux, pour que le libelle
                         reste centre dans le bouton entier (frames « Claude »). */
                      /* ⚠️ 13 px, PAS 0 (21/09/2026). Capture d'Hicham : le badge
                         debordait a gauche et chevauchait la bordure de la carte.
                         `left:0` se cale sur la boite de bordure et ignore la
                         marge interieure. Figma pose le badge a x=13, y=13 dans
                         une carte de 66 px de haut (noeud 3:382639), soit 13 px
                         de chaque cote et un centrage vertical exact. */
                      ...(estVraiFaux ? {
                        position:"absolute",
                        left:"13px",
                        top:"50%",
                        transform:"translateY(-50%)",
                      } : {}),
                    }}>
                      <Box sx={{
                        /* ⚠️ BADGE RELU DANS FIGMA (21/09/2026, lot 3c) :
                           40 px a Tablet (noeud 3:382639, confirme par 20:915 et
                           33:451) et 35 px a Mobile (13:683 et 3:382584). Le code
                           posait 34 et 30 : la pastille etait rabotee aux deux
                           petits paliers, donc plus difficile a viser au doigt. */
                        width:["35px", "40px", "40px", "40px"],
                        height:["35px", "40px", "40px", "40px"],
                        minWidth:["35px", "40px", "40px", "40px"],
                        background:iconBg,
                        /* ⛔ L'OMBRE DURE N'EXISTE PAS DANS LA MAQUETTE (21/09/2026).
                           Le commentaire precedent affirmait « Figma : badge a
                           OMBRE DURE ». Verification faite sur le node : 3:362457
                           rend `bg-[#e8e8e8] flex flex-col items-center
                           justify-center px-[11px] py-[13px]` — ni ombre, ni
                           bordure. Les planches montrent un badge PLAT. C'est la
                           meme affirmation non verifiee que le « jeton Figma
                           2026 » invoque pour le jaune #FED64A.
                           La bordure du badge blanc est conservee : elle, se voit
                           sur les planches et sert a le detacher du fond blanc. */
                        border: iconBg === "white" ? "1px solid #212B36" : "none",
                        /* ⛔ 03/10/2026 — ET L'OMBRE DURE EXISTE BIEN, SUR LE BADGE
                           BLANC. Le constat ci-dessus portait sur un AUTRE etat
                           (3:362457, badge gris). Les badges a numero de la
                           planche par defaut la portent aux trois paliers
                           (3:302262, 3:382639, 3:382584) : ombre noire, decalage
                           2 / 2, flou 0, etalement 0,5 — la touche de clavier
                           dessinee. Decision d'Hicham : le quiz suit la maquette. */
                        boxShadow: iconBg === "white" ? "2px 2px 0 0.5px #000000" : "none",
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"center",
                      }}>
                        {(!isAlreadyAnswer && !estVraiFaux) ? (
                          /* Le NUMERO n'existe que sur le QCM. En Vrai/Faux, le
                             choix en cours se marque par un badge noir a check. */
                          <Box component="span" sx={{
                            color: statut === "selected" ? "white" : "text.black",
                            /* ⚠️ CONSIGNE RELUE DANS FIGMA (21/09/2026, lot 3a). Jeton
                   « Text/Desktop/Body/Large » : 20 px, interligne 1,5, aux deux
                   grands paliers ; 15 px en Mobile (3:282136). Cinq formats
                   portaient cinq echelles differentes pour le MEME element. */
                            /* ⚠️ LE NUMERO DU BADGE N'EST PAS UNE CONSIGNE. Mon
                               remplacement en masse du lot 3a lui avait donne l'echelle
                               de la consigne et ajoute un interligne mort, ecrase par le
                               1,2 juste dessous. Trouve par le test des cles dupliquees. */
                            /* 20 px en Tablet comme en Desktop (3:382640), 16 en
                               Mobile (3:382585). */
                            fontSize:["16px", "20px", "20px", "20px"],
                            lineHeight:1.2,
                            userSelect:"none",
                          }}>
                            {i + 1}
                          </Box>
                        ) : (
                          <>
                            {/* L8 / L17 : glyphes repris de l'export Figma */}
                            {(statut === "selected" || statut === "good" || statut === "mustBeSelected") &&
                              <Box component="svg" viewBox="0 0 12 9" sx={{
                                width:["14px", "17px", "17px", "17px"],   /* glyphe de validation */
                                height:"auto",
                                display:"block",
                              }}>
                                <path d="M1.3 4.6 L4.4 7.6 L10.7 1.3" stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                              </Box>
                            }
                            {(statut === "wrong") &&
                              <Box component="svg" viewBox="0 0 10 10" sx={{
                                width:["12px", "15px", "15px", "15px"],   /* glyphe de croix */
                                height:"auto",
                                display:"block",
                              }}>
                                <path d="M1.4 1.4 L8.6 8.6 M8.6 1.4 L1.4 8.6" stroke="white" strokeWidth="2.4" strokeLinecap="round" fill="none"/>
                              </Box>
                            }
                            {(statut === "") &&
                              <Box component="svg" viewBox="0 0 12 2" sx={{
                                width:["12px", "15px", "15px", "15px"],   /* glyphe de croix */
                                height:"auto",
                                display:"block",
                              }}>
                                <path d="M1 1 L11 1" stroke="white" strokeWidth="2.4" strokeLinecap="round" fill="none"/>
                              </Box>
                            }
                          </>
                        )}
                      </Box>
                    </Box>
                    }
                    {/* L7 : « Vrai » et non « VRAI ». En mode editeur on garde
                        la valeur brute, sinon l'admin editerait un texte deja
                        transforme. */}
                    <EditableField
                      stopClickPropagation
                      field={isEditor ? item?.reponse : casseNormale(item?.reponse)}
                      isEditor={isEditor}
                      sx={{
                        color:"text.black",
                        /* 18 px en Tablet comme en Desktop (3:382641). Vrai/Faux :
                           22 px, 16 en Mobile (6:312, 34:1321). */
                        fontSize: estVraiFaux ? ["16px", "22px", "22px", "22px"] : ["15px", "18px", "18px", "18px"],
                        /* Vrai/Faux : libelle centre dans le bouton, avec une
                           gouttiere laissant la place au badge ancre a gauche. */
                        ...(estVraiFaux ? {
                          /* Gouttiere SYMETRIQUE : le badge est hors flux (absolu), donc
                             un padding gauche seul ne decalait pas le badge mais decalait
                             le TEXTE de 18 a 25 px vers la droite — il n'etait pas centre
                             dans le bouton, contrairement a ce que montrent les frames. */
                          padding:["14px 48px", "16px 54px", "18px 62px", "18px 66px"],
                          textAlign:"center",
                          lineHeight:1.15,   /* absent du code ; la branche QCM le posait deja */
                          width:"100%",
                        } : {
                          padding:0,
                          flex:1,
                          textAlign:"left",
                          lineHeight:1.15,
                        }),
                      }}
                      type={["responses", i, "reponse"]}
                    />
                  </Box>
                )
              })}
              </Box>

              {/* L63 : bloc d'explication de la maquette (« Bonne reponse » /
                  « Mauvaise reponse » suivi du texte). Il n'apparait qu'apres
                  validation, et seulement si le texte a ete redige : les
                  champs success/fail existent en base mais sont vides
                  partout aujourd'hui. En mode editeur on l'affiche toujours,
                  sinon l'admin n'aurait aucun moyen de le remplir. */}
              {/* ⛔ 30/09/2026 — FICHE DE RETOUR DE NAWAL, POINT 2 : « le retour de
                  la bonne reponse s'affiche apres une mauvaise reponse ».
                  CAUSE, reproduite hors navigateur : `estJuste` (l. 106) compare
                  STRICTEMENT (`=== true`, `=== false`), la teinte des cartes
                  (l. 681) teste la VERACITE (`if (item?.isValid)`). Les deux se
                  contredisent sur une question ou AUCUNE proposition ne porte
                  `isValid: true` et ou les autres portent `isValid: null` : la
                  carte choisie devient ROUGE et ce bloc annonce « Bonne reponse ».
                  Cet etat, l'editeur le fabrique tout seul — `QuizzHelper` l. 46
                  pose `isValid: null` sur les propositions creees pendant que
                  « Question sans bonne reponse » est active, et ce null RESTE
                  quand l'interrupteur est eteint.
                  ⛔ `estJuste` N'EST PAS TOUCHEE, et ce n'est pas un choix de
                  confort : `thelab-back/services/notation.js` (l. 95) en est une
                  copie a l'identique, `tests/notation-front.test.js` EXTRAIT
                  celle-ci du present fichier pour les comparer, et elle calcule
                  `userIsValid`, donc le score — qui ne se recalcule jamais
                  (chantier des scores, 27/09). La corriger ici deplacerait des
                  scores deja enregistres.
                  On corrige donc L'AFFICHAGE SEUL, en reprenant le predicat des
                  cartes : sans bonne reponse declaree, ce bloc n'annonce jamais
                  « Bonne reponse ». Un contenu dans cet etat reste un contenu a
                  reparer (l'outil `outils/contenu` le signale deja :
                  « aucune bonne reponse cochee »). */}
              {(() => {
                if (!isAlreadyAnswer || format?.noValidAnswer === true) return null
                const declareUneBonneReponse = (format?.responses || []).some((r) => r && r.isValid)
                const juste = declareUneBonneReponse && estJuste(responses)
                const texte = juste ? format?.success : format?.fail
                if (!isEditor && !(texte && String(texte).trim())) return null
                return (
                  <Box ref={refExplication} sx={{
                    maxWidth: LARGEUR_CARTES,   // Lot G : meme largeur que les cartes (750 px, node 3:302259)
                    width:"100%",
                    /* ⛔ NI BORDURE NI MARGE INTERIEURE sur le bloc de resultat : deux agents
                   d'audit l'ont releve independamment sur la meme ligne. Le bloc
                   ne porte qu'une largeur et son empilement. */
                    
                    display:"flex",
                    flexDirection:"column",
                    gap:["10px", "12px", "12px", "12px"],   /* 10 px en Mobile, 12 ailleurs */
                    textAlign:"left",
                  }}>
                    <Box sx={{
                      color:"text.black",
                      /* ⚠️ 18 px a Desktop et non 20 (noeud 3:362465,
                         `text-[18px] leading-[26px]`). */
                      fontSize:["16px", "18px", "18px", "18px"],
                      lineHeight:"26px",
                    }}>
                      {juste
                        ? languageValues?.formation?.bonneReponse[actLanguage]
                        : languageValues?.formation?.mauvaiseReponse[actLanguage]}
                    </Box>
                    <EditableField
                      field={texte}
                      type={juste ? "success" : "fail"}
                      isEditor={isEditor}
                      sx={{
                        color:"text.black",
                        fontSize:["14px", "16px", "16px", "16px"],   /* 16 px des le palier Tablet */
                        /* ⚠️ 1,55 et non 1,40 : `leading-[1.55]` sur 3:362466
                           (Desktop) et 13:702 (Mobile). */
                        lineHeight:"1.55",
                      }}
                    />
                  </Box>
                )
              })()}
            </Box>
          </Box>
          {debordeEnBas && <FonduBas />}
          </BandeReponse>
          </Box>
        </BlocIllustre>
        </>)}
      </CenterContainer>
      {/* ⛔ PAS DE `BottomBar` SUR CET ECRAN, ET CE N'EST PAS UN OUBLI.
          Les quatre planches de question mettent le CTA dans la rangee de
          controles de la bande, pas dans une barre separee. Le reintroduire
          ferait deux zones basses l'une sous l'autre. */}
    </Box>
  )
}


export default FormatQuizz
